// src/utils/msal.ts
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '@/config/authConfig';

/**
 * Initialize MSAL public client application.
 */
export const msalInstance = new PublicClientApplication(msalConfig);

let initialized = false;

/**
 * Ensure MSAL instance is initialized (only once).
 */
export const ensureMsalInitialized = async () => {
  if (!initialized) {
    await msalInstance.initialize();
    initialized = true;
  }
};
